module.exports = __webpack_public_path__ + "static/media/logo_data_center.b2ead71d.png";